import { ITimeRecordsState } from './types';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { FetchAllTimeRecords, SetCurrentTab, SetFiltersBasedOnTab, SetSearchField } from './actions';
import { TimeRecordsService } from './service';
import { tap } from 'rxjs/operators';
import { SubcontractorService } from 'src/app/modules/logged/subcontractors/store/service';
import { IPagination } from 'src/app/modules/authorization/store/types';
import { ISubcontractor } from 'src/app/modules/logged/subcontractors/store/types';

const defaults: ITimeRecordsState = {
    isLoading: false,
    currentTab: null,
    searchField: '',
    siteManagerTimeRecordsFilters: {
        page: 1,
        results: 100,
        sort: 'fullnameASC',
        subcontractorID: null,
        workLocationID: null,
        date: new Date()
    },
    siteManagerTimeRecords: null,

    timerRecords: null
};

@State<ITimeRecordsState>({
    name: 'timeRecords',
    defaults
})

@Injectable()
export class TimeRecordsState {

    @Selector()
    static isLoading(state: ITimeRecordsState) {
        return state.isLoading;
    }

    @Selector()
    static currentTab(state: ITimeRecordsState) {
        return state.currentTab;
    }

    @Selector()
    static searchField(state: ITimeRecordsState) {
        return state.searchField;
    }

    @Selector()
    static siteManagerTimeRecordsFilters(state: ITimeRecordsState) {
        return state.siteManagerTimeRecordsFilters;
    }

    @Selector()
    static siteManagerTimeRecords(state: ITimeRecordsState) {
        return state.siteManagerTimeRecords;
    }


    @Selector()
    static timeRecords(state: ITimeRecordsState) {
        return state.timerRecords;
    }

    constructor(
        private timeRecordsService: TimeRecordsService,
        private subcontractorService: SubcontractorService,    
    ) {}

    @Action(SetCurrentTab)
    SetCurrentTab(ctx: StateContext<ITimeRecordsState>, action: SetCurrentTab) {
        const state = ctx.getState();
        ctx.patchState({currentTab: action.tab || state.currentTab || 'GENERAL'});
        ctx.dispatch(new SetFiltersBasedOnTab({page: 1, ...action.filters}));
    }

    @Action(SetSearchField)
    SetSearchField(ctx: StateContext<ITimeRecordsState>, action: SetSearchField) {
        ctx.patchState({searchField: action.value});
        ctx.dispatch(new SetFiltersBasedOnTab({page: 1}));
    }

    @Action(SetFiltersBasedOnTab)
    SetFiltersBasedOnTab(ctx: StateContext<ITimeRecordsState>, action: SetFiltersBasedOnTab) {
        let state = ctx.getState();
        ctx.patchState({isLoading: true});
        switch (state.currentTab) {
            default:
                ctx.patchState({
                    siteManagerTimeRecordsFilters: {
                        ...state.siteManagerTimeRecordsFilters,
                        ...action.filters
                    }
                });
                state = ctx.getState();
                return this.subcontractorService.fetchTimeRecordsForSiteManager({
                    ...state.siteManagerTimeRecordsFilters,
                    search: state.searchField,
                })
                    .pipe(tap((pagination: IPagination<ISubcontractor>) => ctx.patchState({
                        siteManagerTimeRecords: pagination,
                        isLoading: false
                    })));
        }
    }

    @Action(FetchAllTimeRecords)
    FetchAllTimeRecords(ctx: StateContext<ITimeRecordsState>, action: FetchAllTimeRecords) {
        return this.timeRecordsService.fetchAllTimeRecords(action.params)
            .pipe(
                tap(response => {
                    ctx.patchState({
                        timerRecords: response.results
                    });
                })
            );
    }

}
